import React from 'react'

function ShowCpMaster() {
  return (
    <div>ShowCpMaster</div>
  )
}

export default ShowCpMaster